/**
 * Cookie consent state. Nothing non-essential may load unless this says so.
 * Necessary cookies are always on because the app cannot run without them.
 */
export const CONSENT_KEY = "pm_cookie_consent";
export const CONSENT_VERSION = 2;
export const OPEN_CONSENT_EVENT = "postmint:open-cookie-settings";
export const CONSENT_CHANGED_EVENT = "postmint:consent-changed";

export const DEFAULT_CONSENT = { necessary: true, preferences: false, analytics: false, marketing: false };

export const readConsent = () => {
  try {
    const raw = localStorage.getItem(CONSENT_KEY);
    if (!raw) return null;
    const saved = JSON.parse(raw);
    if (saved.version !== CONSENT_VERSION) return null;
    return { ...DEFAULT_CONSENT, ...saved, necessary: true };
  } catch (e) {
    console.error("Could not read cookie consent", e);
    return null;
  }
};

export const writeConsent = (choice) => {
  const record = {
    ...DEFAULT_CONSENT,
    ...choice,
    necessary: true,
    version: CONSENT_VERSION,
    ts: new Date().toISOString(),
  };
  try {
    localStorage.setItem(CONSENT_KEY, JSON.stringify(record));
  } catch (e) {
    console.error("Could not store cookie consent", e);
  }
  window.postMintConsent = record;
  window.dispatchEvent(new CustomEvent(CONSENT_CHANGED_EVENT, { detail: record }));
  return record;
};

export const hasConsent = (category) => Boolean(readConsent()?.[category]);

export const openCookieSettings = () => window.dispatchEvent(new Event(OPEN_CONSENT_EVENT));

/**
 * Analytics and marketing scripts must be registered here instead of being added to index.html,
 * so they can never fire before consent. Nothing is registered today.
 */
export const loadConsentedScripts = (consent) => {
  if (consent?.analytics) {
    // Add your analytics loader here — it will only ever run after analytics consent.
  }
  if (consent?.marketing) {
    // Add your marketing/advertising loader here — consent-gated in the same way.
  }
};
